import axios from 'axios';

export default axios.create({
  headers: {
    'Client-Api-Key': 'MD538251hdayD!xndyJ',
  },
});
